import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TableRow, Switch, Box, Paper, IconButton } from "@material-ui/core";
import { styled } from '@mui/material/styles';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { useQuery } from 'react-query';
import { PERMISSION_API_URL } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import EditPenIcon from 'src/svgComponents/EditPenIcon'
import BinIcon from 'src/svgComponents/BinIcon'
import Stack from '@mui/material/Stack';
import { Button, Modal, TextField, InputBase } from "@mui/material";
import { useNavigate } from "react-router";
import SearchIcon from "src/svgComponents/SearchIcon";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "react-query";
import { useSnackbar } from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment'
import LoadingScreen from 'src/components/LoadingScreen'
import useStore from 'src/contexts/AuthProvider'
import AppTooltip from "src/components/common/AppTooltip";
import { Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';
const _ = require('lodash');

export default function MasterPassword() {
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(0);
    const [modelTitle, setmodelTitle] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');

    const [filterName, setFilterName] = useState('');
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [Id, setId] = useState("");
    const permissionsData = useStore(state => state.permissions);
    const [loding, setLoding] = useState(true);
    const [open, setOpen] = useState(false);
    const [oldPasswordfield, setFieldFlag] = useState(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#ffffff',

        },
        '&:nth-of-type(even)': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
        },
        // hide last border
        '& td, & th': {
            border: 0,
        },
    }));

    async function getPasswordDetail(page, filterName) {
        // console.log("get permission data api")
        const response = await axiosPrivate.get(PERMISSION_API_URL.getPasswordDetail, { params: { params: { type: '1', page: page + 1, limit: rowsPerPage, search: filterName } } });
        return response.data;
    }
    const { isLoading, data: appVersion, refetch } = useQuery(['appVersion', page, filterName], (page, filterName) => getPasswordDetail(), { keepPreviousData: true, })

    useEffect(() => {
        if (appVersion) {
            setFieldFlag(true);
            setId(appVersion._id);
        }
        setTimeout(() => {
            setLoding(false);
        }, 500);
    }, [appVersion])




    const completedSchema = Yup.object().shape({
        password: Yup.string().required("Password is required"),
        // old_password: Yup.string().required("Old Password is required"),
        confirm_password: Yup.string()
            .oneOf([Yup.ref("password"), null], "Confirm password must match with password")
            .required("Confirm Password is required"),
    });

    const formik = useFormik({
        initialValues: {
            old_password: '',
            password: '',
            confirm_password: '',
        },
        validationSchema: completedSchema,
        onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
            const informationObj = {
                password: values.password,
                old_password: values.old_password,
            };
            await updateVersion(informationObj);
            setSubmitting(false);
            resetForm();

        },
    });

    const { mutateAsync: updateVersion } = useMutation(
        async (data) => {
            return await axiosPrivate.post(PERMISSION_API_URL.addUpdatePassword, JSON.stringify(data))
        },
        {
            onSuccess: ({ data }) => {
                refetch();
                enqueueSnackbar(data.message, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                    autoHideDuration: 2000,
                });
            },
            onError: (error) => {
                if (error.response?.data?.message) {
                    enqueueSnackbar(error.response?.data?.message, {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                        autoHideDuration: 2000,
                    });
                }
                const errorData = error.response.data.errors;
    
                Object.keys(errorData).forEach((key) => {
                   if (key === "password") {
                      setFieldError(key, errorData[key]);
                   } else {
                      setFieldError(key, errorData[key]);
                   }
                });
                
            },
        }
    );
    const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps } = formik;

    return (
        <>
            {/* {loding ? <LoadingScreen /> : <>
      }
    </> */}
            <div className="card" style={{ "width": "45%" }}>
                <h5 className="card-header">Master Password</h5>
                <div className="card-body">
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" onSubmit={handleSubmit}>
                            <div className="row">
                                {oldPasswordfield == true ? <div className="form-group mb-4">
                                    <TextField
                                        label='Old Password'
                                        autoComplete='off'
                                        fullWidth
                                        variant='outlined'
                                        {...getFieldProps("old_password")}
                                        error={Boolean(touched.old_password && errors.old_password)}
                                        helperText={touched.old_password && errors.old_password}
                                    />
                                </div> : ''}
                                <div className="form-group mb-4">
                                    <TextField
                                        label='Master Password'
                                        autoComplete='off'
                                        fullWidth
                                        variant='outlined'
                                        {...getFieldProps("password")}
                                        error={Boolean(touched.password && errors.password)}
                                        helperText={touched.password && errors.password}
                                    />
                                </div>
                                <div className="form-group mb-4">
                                    <TextField
                                        label='Confirm Password'
                                        autoComplete='off'
                                        fullWidth
                                        variant='outlined'
                                        {...getFieldProps("confirm_password")}
                                        error={Boolean(touched.confirm_password && errors.confirm_password)}
                                        helperText={touched.confirm_password && errors.confirm_password}
                                    />
                                </div>
                            </div>
                            <div className="row">

                                <div className="col-md-3 m-auto">
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                                    >
                                        submit
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </FormikProvider>
                </div>
            </div>
            <div className="modal_card_body custom_scrollbar max_hight500">

            </div>
        </>
    )
}

